import React from 'react';

import { getSize, Size } from './utils';

interface Props {
    color: string;
    controlColor?: string;
    size?: Size;
    transparentControl?: boolean;
}

export const PauseIcon: React.FC<Props> = ({ color, controlColor = '#F9F9F9', size = 's', transparentControl }) => {
    const sizePx = getSize(size);

    return transparentControl ? (
        <svg width={sizePx} height={sizePx} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm-1-6.5a1 1 0 11-2 0v-7a1 1 0 012 0v7zm3 1a1 1 0 001-1v-7a1 1 0 10-2 0v7a1 1 0 001 1z"
                fill={color}
            />
        </svg>
    ) : (
        <svg width={sizePx} height={sizePx} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11z" fill={color} />
            <path
                d="M8.5 15V7M13.5 15V7"
                stroke={controlColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
